module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "event-list"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "輸入藥物名稱以搜尋事件"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), (_vm.events.length === 0) ? _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [(_vm.fetchStatus === 'start') ? _c('Loader') : _vm._e(), (_vm.fetchStatus === 'done') ? _c('h3', [_vm._v("無事件紀錄")]) : _vm._e()], 1) : _c('div', {
    staticClass: "drug-search-list",
    staticStyle: {
      "height": "91%"
    }
  }, _vm._l((_vm.events), function(item) {
    return _c('div', {
      class: {
        'btn': true, 'drug-button': true, 'drug-selected': item.selected, 'returned-schedule': (_vm.number2 && item.checked)
      },
      on: {
        "click": function($event) {
          return _vm.selectEvent(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "drug-head"
    }, [_c('div', {
      staticClass: "drug-head-icon-wrap"
    }, [_c('font-awesome-layers', {
      staticClass: "fa-lg"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": _vm.circleIcon,
        "size": "lg",
        "color": "yellowgreen"
      }
    }), _c('font-awesome-icon', {
      attrs: {
        "icon": _vm.noteMedicalIcon,
        "transform": "shrink-6 right-2",
        "color": "white"
      }
    })], 1)], 1), _c('div', {
      staticClass: "drug-head--content"
    }, [(item.medication.CGMH_number !== null) ? _c('span', [_vm._v("[ " + _vm._s(item.medication.CGMH_number) + " - "), _c('span', [_vm._v(_vm._s(item.medication.code) + " ]")])]) : _vm._e(), _c('span', [_vm._v(_vm._s(item.medication.generic_name))]), _c('span', [_c('small', [_vm._v(_vm._s(item.event_type.event_name_zh) + "事件")])])])]), _c('div', {
      staticClass: "drug-item"
    }, [_c('div', {
      staticClass: "info-col"
    }, [_vm._m(0, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(item.employee_name))])])]), _c('div', {
      staticClass: "info-col",
      staticStyle: {
        "width": "50px"
      }
    }, [_vm._m(1, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(item.number1))])])]), _c('div', {
      staticClass: "info-col"
    }, [_vm._m(2, true), _c('div', {
      staticClass: "info-col-content"
    }, [(item.med_record_no === '' || item.med_record_no === undefined || item.med_record_no === null) ? _c('p', [_vm._v("未設定")]) : _c('p', [_vm._v(_vm._s(item.med_record_no))])])]), _c('div', {
      staticClass: "info-col"
    }, [_vm._m(3, true), (item.drug_storage) ? _c('div', {
      staticClass: "info-col-content"
    }, [(item.batch_no === '' || item.batch_no === undefined || item.batch_no === null) ? _c('p', [_vm._v("未設定")]) : _c('p', [_vm._v(_vm._s(item.batch_no))])]) : _vm._e()]), _c('div', {
      staticClass: "info-col",
      staticStyle: {
        "width": "130px"
      }
    }, [_vm._m(4, true), _c('div', {
      staticClass: "info-col-content"
    }, [_c('p', [_vm._v(_vm._s(_vm._f("readableTime")(item.record_time)))])])]), _c('div', {
      staticClass: "info-col"
    }, [(item.medication.restrained_class > 0) ? _c('div', {
      staticClass: "label-badge restrained-badge"
    }, [_c('span', [_vm._v("管制藥")])]) : _vm._e(), (item.event_type.event_name === 'FETCH' && item.related_events.length === 0) ? _c('div', {
      staticClass: "label-badge",
      class: {
        'returned-badge': item.checked, 'unretured-badge': item.checked === false
      }
    }, [(item.checked) ? _c('span', [_vm._v("已退藥")]) : _c('span', [_vm._v("未退藥")])]) : _vm._e(), (item.event_type.event_name === 'FETCH' && item.checked && item.related_events.length > 0) ? _c('div', {
      staticClass: "label-badge",
      class: {
        'returned-badge': item.checked
      }
    }, _vm._l((item.related_events), function(e) {
      return _c('span', [_vm._v(_vm._s(_vm._f("zhLabel")(e.event_type.event_name)) + " ")])
    }), 0) : _vm._e()])])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("使用者")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("數量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("病歷號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("批號")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-col-head"
  }, [_c('span', [_vm._v("時間")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44250478","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/EventTable.vue
// module id = 1455
// module chunks = 1